import { OrganisationPermissionConstants } from "../../../constants";
import { DeveloperSingleCardWithTabsTemplate } from "../../../templates";
import { useAuth } from "../../../useAuth";
import { getSettingsAuditHistoryRoute } from "../../../utils/routes";

const Settings = (): JSX.Element => {
  const { hasPermission, currentUserType } = useAuth();

  let tabsList = [
    { route: "/d/settings/organisation", label: "Organisation" },
    {
      route: "/d/settings/marketing-assets",
      label: "Marketing assets",
    },
    {
      route: "/d/settings/project-access",
      label: "Project access",
    },
    {
      route: "/d/settings/document-types",
      label: "Document types",
    },
    // { route: "/d/settings/embedding", label: "Embedding" },
  ];

  if (hasPermission(OrganisationPermissionConstants.READ_ORGANISATION_USERS))
    tabsList = [
      {
        route: "/d/settings/users",
        label: "Users",
      },
      ...tabsList,
    ];

  tabsList = [
    ...tabsList,
    {
      route: getSettingsAuditHistoryRoute(currentUserType),
      label: "Audit history",
    },
  ];

  return (
    <div>
      <DeveloperSingleCardWithTabsTemplate activeElement="Settings" pageTitle="Settings" tabsList={tabsList} />
    </div>
  );
};

export default Settings;
